import { useParams } from "react-router-dom";

import { date } from "core/util";
import { vehicleCancellationApi } from "serverApi";
import { CancellationReason, VehicleCancellationReason } from "types";

const defaultCancellationDates = {
    [VehicleCancellationReason.INSURER_DEATH]: date.todayDateAsIsoString,
};

const applyDefaultDates = (reasons: CancellationReason[]): CancellationReason[] =>
    reasons.map((reason) => ({
        ...reason,
        defaultCancellationDate: reason.defaultCancellationDate ?? defaultCancellationDates[reason.code] ?? null,
    }));

export function useCancellationReasons() {
    const { idObject } = useParams();

    const getCancellationReasonsForChange = async (changeSheetId: string): Promise<CancellationReason[]> => {
        const [error, res] = await vehicleCancellationApi.getCancellationReasons(idObject, changeSheetId);
        if (error) {
            throw error;
        }
        return applyDefaultDates(res.body);
    };

    return {
        getCancellationReasonsForChange,
    };
}
